module.exports = __webpack_public_path__ + "static/brand-nationstar-5a26cac547bbae6c469334782bdbb8ef.png";